// extracted by mini-css-extract-plugin
module.exports = {"container":"consentPageContent_container__sZHFi"};